/**
 * @description : Handles overlay display.
**/
function overlayService() {

  let overlayVisibility = false;
  let pfwOverlayVisibility = false;
  let pfwTrackingNumber;

  return {

    toggleOverlay: () => {

      overlayVisibility = !overlayVisibility;

    },

    togglePfwOverlay: () => {

      pfwOverlayVisibility = !pfwOverlayVisibility;

    },

    setPfwTrackingNumber: (trackingNumber) => {

      pfwTrackingNumber = trackingNumber;

    },
    getPfwTrackingNumber: () => pfwTrackingNumber,
    getOverlayState: () => overlayVisibility,
    getPfwOverlayState: () => pfwOverlayVisibility

  };

}

export default overlayService;


// WEBPACK FOOTER //
// ./src/services/overlay.service.js